import { useState, useEffect } from "react";
import axios from "axios";
import {
  Box,
  Snackbar,
  Alert,
  Button,
  List,
  ListItem,
  ListItemText,
  Typography,
  Divider,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
} from "@mui/material";

const MONTHS = [
  "January", "February", "March", "April",
  "May", "June", "July", "August",
  "September", "October", "November", "December"
];

export default function Reports() {
  const now = new Date();
  const [selectedMonth, setSelectedMonth] = useState(now.getMonth());
  const [selectedYear, setSelectedYear] = useState(now.getFullYear());
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });
  const [importDays, setImportDays] = useState({datestart:new Date(), dateend: new Date(new Date().getTime() - 86400000)})
  const [days, setDays] = useState([]);
  const [data, setData] = useState({});

  const handleImportTransactions = async () => {
    const {datestart, dateend} = importDays
    try {
      const res = await axios.get(`http://localhost:5000/importtransactions?datestart=${datestart}&dateend=${dateend}`, {
        headers: { "Content-Type": "application/json" },
      });
      console.log("✅ Import successful:", res.data);
      setSnackbar({
        open: true,
        message: "Transactions imported successfully!",
        severity: "success",
      });
    } catch (error) {
      console.error("❌ Import failed:", error);
      setSnackbar({
        open: true,
        message: "Failed to import transactions.",
        severity: "error",
      });
    }
  };
  
  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const generateDaysOfMonth = (year, month) => {
    const dayList = [];
    const daysInMonth = new Date(year, month + 1, 0).getDate();

    for (let i = 1; i <= daysInMonth; i++) {
      const date = new Date(year, month, i);
      dayList.push({
        label: date.toLocaleDateString("en-CA"),
        iso: date.toISOString(),
      });
    }
    setDays(dayList);
  };

  useEffect(() => {
    generateDaysOfMonth(selectedYear, selectedMonth);
  }, [selectedMonth, selectedYear]);

  const getOverviewOfDay = async (startDate, endDate) => {
    try {
      const res = await axios.get(
        `http://localhost:5000/dailyoverview?datestart=${startDate}&dateend=${endDate}`,
        { headers: { "Content-Type": "application/json" } }
      );
      setData((prev) => ({ ...prev, [endDate]: res.data }));
    } catch (error) {
      console.error("Error fetching overview:", error);
    }
  };

  // Create dynamic year list (e.g., 5 years back & forward)
  const yearOptions = [];
  for (let y = now.getFullYear() - 5; y <= now.getFullYear(); y++) {
    yearOptions.push(y);
  }

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h5" gutterBottom>
        📅 Daily Reports for {MONTHS[selectedMonth]} {selectedYear}
      </Typography>

      {/* Dropdowns for month/year */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={6} sm={4} md={3}>
          <FormControl fullWidth>
            <InputLabel id="month-label">Month</InputLabel>
            <Select
              labelId="month-label"
              value={selectedMonth}
              label="Month"
              onChange={(e) => setSelectedMonth(e.target.value)}
            >
              {MONTHS.map((month, index) => (
                <MenuItem key={index} value={index}>
                  {month}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={6} sm={4} md={3}>
          <FormControl fullWidth>
            <InputLabel id="year-label">Year</InputLabel>
            <Select
              labelId="year-label"
              value={selectedYear}
              label="Year"
              onChange={(e) => setSelectedYear(e.target.value)}
            >
              {yearOptions.map((year) => (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      <Button
        variant="contained"
        color="primary"
        onClick={handleImportTransactions}
        sx={{ mb: 2 }}
      >
        🚀 Import Transactions
      </Button>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
      <List>
        {days.map((day) => (
          <Box key={day.iso}>
            <ListItem
              secondaryAction={
                <Button
                  variant="outlined"
                  size="small"
                  onClick={() => getOverviewOfDay(day.iso, new Date(new Date(day.iso).getTime() + 86400000).toISOString())}
                >
                  Get Overview
                </Button>
              }
            >
              <ListItemText
                primary={day.label}
                secondary={
                  data[day.iso]
                    ? `📊 ${JSON.stringify(data[day.iso])}`
                    : "No data loaded"
                }
              />
            </ListItem>
            <Divider />
          </Box>
        ))}
      </List>
    </Box>
  );
}
